define(['jquery',
        'core/urls'],
    function($, urls) {

        function zendeskConnectivityCheck(){
            $.ajax({
                type: 'GET',
                url: urls['ticketsource:zendesk-connectivity'](),
                dataType: 'json',
                success: function(data){
                    if(data.status === 'connected'){
                        $('#connectivity-status-checking').hide();
                        $('#connectivity-status p').hide();
                        $('#connectivity-status-connected').show();
                        $('#fix-upgrade-needed').hide();
                        $('#upgrade-needed-alert').hide();
                    } else if(data.status === 'disconnected') {
                        $('#connectivity-status-checking').hide();
                        $('#connectivity-status-notconnected').show();
                        $('#connectivity-status p').show();
                        $('#fix-upgrade-needed').hide();
                        $('#upgrade-needed-alert').hide();
                    } else if(data.status === 'upgrade_needed') {
                        $('#connectivity-status-checking').hide();
                        $('#connectivity-status p').hide();
                        $('#connectivity-status-upgrade-needed').show();
                        $('#fix-upgrade-needed').show();
                        $('#upgrade-needed-alert').show();
                    }
                }
            });
        }

        return {
            init: function() {
                zendeskConnectivityCheck();

                $("#upgrade-needed-alert").click( function() {
                   $('#zendeskform').submit();
                });

            }
        };
    }
);